var map = {
	"./acnh.png": "ef50",
	"./ar.png": "393f",
	"./ardrive.png": "247f",
	"./arg.png": "e9b1",
	"./bank.png": "e5e1",
	"./bnb.png": "bc67",
	"./cfx.png": "8e50",
	"./dai.png": "e86a",
	"./default.svg": "b4fb",
	"./dodo.png": "38c1",
	"./eth.png": "c67a",
	"./fox.png": "8664",
	"./fra.png": "7dd7",
	"./glmr.png": "b0ac",
	"./lat.png": "3160",
	"./mask.png": "e028",
	"./permaswap-logo.png": "cc03",
	"./pia.png": "2124",
	"./sos.png": "548c",
	"./t4ever.png": "a009",
	"./tar.png": "6388",
	"./tardrive.png": "9977",
	"./tusdc.png": "eadd",
	"./uni.png": "b009",
	"./usdc.png": "012e",
	"./usdt.png": "5d28",
	"./vrt.png": "e7e1",
	"./wbtc.png": "94aa",
	"./xsgd.png": "25f0",
	"./xyz.png": "ee79",
	"./zlk.png": "558e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23b0";